import { render, staticRenderFns } from "./LoyaltyPrograms.template.vue?vue&type=template&id=2a7f8587&scoped=true&"
var script = {}
import style0 from "./LoyaltyPrograms.template.vue?vue&type=style&index=0&id=2a7f8587&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7f8587",
  null
  
)

export default component.exports